import React, { useContext, Fragment } from 'react';
import moment from 'moment';
import { List, SpinLoading, ErrorBlock, Ellipsis } from 'antd-mobile';
import styled from 'styled-components';
import { getActiveWorkDescription, getDateTimeFormat, getFormattedTotalTime } from '../utils/helpers';
import UserSelfContext from '../utils/self-context';

const WorkEntries = styled(List)`
	width: 100%;
	padding: 12px 0px 12px 0px;
	.adm-list-item-content-extra {
		display: flex;
	}
`;

const StartEndTimeSeparator = styled.span`
	margin: 0px 4px;
`;

const SpinWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
`;

const WorkDescription = styled.div`
	font-size: var(--adm-font-size-9);
	margin: 4px 0px;
`;

function WorkEntriesList(props) {
	const {
		workEntries,
		loading,
		onWorkEntryClick
	} = props;
	const { userSelf } = useContext(UserSelfContext);

	function getList() {
		if (!workEntries.length) {
			return <ErrorBlock
				style={{ paddingTop: 12 }}
				title="No work entries found"
				status='empty'
			/>;
		}

		return <WorkEntries>
			{workEntries.map(we => (
				<List.Item
					onClick={() => !!we.work_end && onWorkEntryClick(we)}
					clickable={!!we.work_end}
					key={we.id}
					title={<Fragment>
						<span>{`${we.work_start ? moment(we.work_start).format(getDateTimeFormat(userSelf)) : '-'}`}</span>
						<StartEndTimeSeparator> - </StartEndTimeSeparator>
						<span>{`${we.work_end ? moment(we.work_end).format(getDateTimeFormat(userSelf)) : 'Working...'}`}</span>
					</Fragment>}
					description={<Fragment>
						Total: {we.work_duration ? getFormattedTotalTime(we.work_duration) : '00h 00min'}
						<StartEndTimeSeparator> &middot; </StartEndTimeSeparator>
						Break: {we.break_duration ? getFormattedTotalTime(we.break_duration) : '00h 00min'}
					</Fragment>}
				>
					<WorkDescription>
						<Ellipsis direction='end' rows={3} content={getActiveWorkDescription(we)} />
					</WorkDescription>
				</List.Item>
			))}
		</WorkEntries>;
	}

	return (
		loading ? <SpinWrapper><SpinLoading style={{ '--size': '48px' }} /></SpinWrapper> : getList()
	);
}

export default WorkEntriesList;
